import React from 'react';
import type { FC } from 'react';

import { useWarehouseTaskCount } from '@admin/hooks/use_warehouse_task_count';

export const NavBarWarehouseTaskCountBadge: FC = () => {
  const count = useWarehouseTaskCount();
  if (!count) return null;
  return <span className="badge badge-warning">{count}</span>;
};
